import { motion } from "framer-motion";
import React from "react";
import { BodyText, SaveButton } from "../../styles/global";
import { LeftSection, RightSection } from "../header/Header.style";
import { WrapperHero, TitleText, ButtonWrapper } from "./Hero.styles";

export const HeroSectionOne = () => {
  return (
    <>
      <WrapperHero>
        <LeftSection>
          <TitleText>
            <div>
              <p className="content_header">
                Securing the future of the african children and the unborn
                generations via financial literacy.
              </p>
            </div>

            <BodyText>
              <p className="saveResponsibly_content">
                Save responsibly in advance for your kids so they can achieve
                future desired goals with ease or become stakeholders via equity
                syndicate investment in the emerging african economy and the
                world at large.
              </p>
            </BodyText>

            <h4>
              <b>Target savings for kids</b>
            </h4>

            <BodyText>
              Become a super parent by hitting all savings goal with ease and
              swiftly for your kids, your kids stand a chance of winning from
              our scholarship scheme worth hundreds of millions, you earn a cash
              reward on your savings discipline for the kids and a host of lucky
              families will qualify for our annual travels and tours.
            </BodyText>
          </TitleText>

          <ButtonWrapper>
            <SaveButton to="/">Start Saving</SaveButton>
          </ButtonWrapper>
        </LeftSection>

        <RightSection>
          <motion.div
            whileInView={{ scale: 1, opacity: 1 }}
            initial={{ scale: 0.5, opacity: 0 }}
            transition={{ duration: 1.2, stiffness: 1 }}
          >
            <img src="img/Frame 19.jpg" alt="" />
          </motion.div>
        </RightSection>
      </WrapperHero>
    </>
  );
};
